import { render, staticRenderFns } from "./InfoGudang.vue?vue&type=template&id=779b589e&"
import script from "./InfoGudang.vue?vue&type=script&lang=js&"
export * from "./InfoGudang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports